<template>
  <td>
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.administrative_roles') }}:</strong>
    </h6>
    <div
      v-if="isSet(managementRoles) && isSet(managementRoles[0])"
      class="tag-container"
    >
      <span
        v-for="(_, valueKey) in managementRoles"
        :key="valueKey"
        class="tag-wrapper"
        :style="{ width: tagWidth }"
      >
        <el-tag type="info" class="custom-tag">
          <div>
            <strong>{{ $t('common_words.name') }}:</strong>
            {{ infoData.mgmtRolesSelected[valueKey] }}
          </div>
          <div>
            <strong>{{ $t('common_words.associated_users2') }}:</strong>
          </div>
          <div class="user-list">
            <span
              v-for="(user, index) in limitedUsers(valueKey)"
              :key="index"
              class="user-item"
            >
              - {{ user }}
            </span>
          </div>

          <div
            v-if="
              infoData.mgmtRolesUsersSelected &&
              Array.isArray(infoData.mgmtRolesUsersSelected[valueKey]) &&
              infoData.mgmtRolesUsersSelected[valueKey].length > 5
            "
            class="show-more-container"
          >
            <el-button
              type="text"
              class="show-more-btn"
              @click="toggleShowMore(valueKey)"
            >
              {{
                expanded[valueKey]
                  ? $t('common_words.see_less')
                  : $t('common_words.see_more')
              }}
            </el-button>
          </div>
        </el-tag>
      </span>
    </div>
    <el-tag v-else type="warning" effect="dark" class="mt-2">{{
      $t('common_words.no_assignment')
    }}</el-tag>
  </td>
</template>

<script>
import { isset } from 'src/util/Util.js';

export default {
  name: 'td-info-management-roles',
  props: {
    managementRoles: {
      required: true,
    },
    infoData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: {}, // Controla qué roles están expandidos
    };
  },
  computed: {
    /**
     * Calcula el ancho de cada tag en función de la cantidad de roles administrativos
     */
    tagWidth() {
      const numRoles = this.managementRoles.length
        ? this.managementRoles.length
        : 0;
      if (numRoles === 0) return '100%';

      return `calc(${100 / numRoles}% - 8px)`; // Resta 8px por los márgenes
    },
  },
  methods: {
    limitedUsers(valueKey) {
      const users =
        this.infoData &&
        this.infoData.mgmtRolesUsersSelected &&
        Array.isArray(this.infoData.mgmtRolesUsersSelected[valueKey])
          ? this.infoData.mgmtRolesUsersSelected[valueKey]
          : [];

      return this.expanded[valueKey] ? users : users.slice(0, 5);
    },

    toggleShowMore(valueKey) {
      this.$set(this.expanded, valueKey, !this.expanded[valueKey]);
    },

    isSet(data) {
      return isset(data);
    },
  },
};
</script>

<style scoped>
/* Contenedor flexible para que los roles se distribuyan bien */
.tag-container {
  display: flex;
  flex-wrap: wrap; /* Permite que los elementos pasen a la siguiente línea */
  gap: 8px; /* Espacio entre los tags */
  justify-content: flex-start; /* Alinea los tags al inicio */
  width: 99%; /* Ocupar todo el ancho disponible */
}

/* Cada tag ocupa un ancho proporcional */
.tag-wrapper {
  flex-grow: 1;
  min-width: 150px;
}

/* Estilos para los tags */
.custom-tag {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between; /* Empuja el contenido y el botón "Ver más" hacia abajo */
  height: auto;
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
  padding: 8px;
  position: relative;
}

/* Lista de usuarios dentro del tag */
.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 20px;
}

/* Espaciado para los nombres de usuario */
.user-item {
  display: inline-block;
  margin-right: 8px;
}

/* Contenedor del botón "Ver más", fijo en la parte inferior derecha */
.show-more-container {
  position: absolute;
  bottom: 0px;
  right: 10px;
}

/* Botón "Ver más" */
.show-more-btn {
  font-size: 12px;
  color: #39653b;
  cursor: pointer;
  text-decoration: underline;
}
</style>
